export const environment = {
  production: false,
  adminApiUrl: 'https://admin.staging.getlilo.io/admin',
  dictionariesApiUrl: 'https://admin.staging.getlilo.io/protocols/dictionaries',
  packagesApiUrl: 'https://admin.staging.getlilo.io',
  authorizationApiUrl: 'https://api.staging.getlilo.io/access',
  protectedApiUrl: 'https://api.staging.getlilo.io/protected',
};
